import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const initialAssessmentDayWise = [
  { label: "Mon", avgTime: 7.4 },
  { label: "Tue", avgTime: 7.8 },
  { label: "Wed", avgTime: 7.2 },
  { label: "Thu", avgTime: 8.1 },
  { label: "Fri", avgTime: 7.6 },
  { label: "Sat", avgTime: 8.4 },
  { label: "Sun", avgTime: 8.0 },
];

// Tooltip formatter
const TimeTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white p-3 rounded-lg shadow-md border text-sm min-w-[150px]">
      <p className="font-semibold mb-1">{label}</p>
      <div className="flex justify-between font-semibold text-blue-900">
        <span>Avg Time</span>
        <span>{payload[0].value} min</span>
      </div>
    </div>
  );
};

export default function InitialAssesmentTimeAreaLineChart() {
  return (
    <ResponsiveContainer width="100%" height={"100%"}>
      <AreaChart
        data={initialAssessmentDayWise}
        margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
        barCategoryGap={"20%"}
      >
        <defs>
          <linearGradient id="triageGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#3B82F6" stopOpacity={0.4} />
            <stop offset="100%" stopColor="#3B82F6" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#e0e0e0"
        />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 12 }}
          stroke="#666"
          interval={0}
        />
        <YAxis
          domain={[0, 12]}
          tick={{ fontSize: 12 }}
          tickFormatter={(v) => `${v}m`}
        />
        <Tooltip content={<TimeTooltip />} />

        <Area
          type="monotone"
          dataKey="avgTime"
          stroke="#3B82F6"
          fill="url(#triageGradient)"
          strokeWidth={3}
          dot={{
            r: 3,
            stroke: "#3B82F6",
            strokeWidth: 3,
            fill: "#3B82F6",
          }}
          activeDot={{ r: 3 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
